import { buildChoiceID } from "./ModalChoices.helper";

const SingleChoice = ({ choice, isChecked, onSelection = () => {} }) => {
  const { name, value, description, disabled } = choice;
  const onSelected = disabled ? undefined : () => onSelection(value);

  return (
    <div id={buildChoiceID(value)} onClick={onSelected}>
      <input
        type="radio"
        name="select"
        id={value}
        value={value}
        aria-labelledby={value}
        readOnly={true}
        checked={isChecked}
        disabled={disabled}
      />
      <label htmlFor={value}>
        <h2>{name}</h2>
        <p>{description}</p>
      </label>
    </div>
  );
};

export default SingleChoice;
